import Swiper from 'swiper/bundle'

export default function ReviewSlider () {
  const SWIPER = new Swiper('.mtt-reviews .swiper-container', {
    init: false,
    slidesPerView: 1.2,
    speed: 800,
    spaceBetween: 24,
    watchOverflow: true,
    breakpoints: {
      501: {
        spaceBetween: 32,
        slidesPerView: 1.5
      },
      801: {
        spaceBetween: 32,
        slidesPerView: 2
      },
      1001: {
        spaceBetween: 32,
        slidesPerView: 2.5
      },
      1201: {
        spaceBetween: 32,
        slidesPerView: 3
      }
    }
  })

  if (document.querySelector('.mtt-reviews .swiper-container')) SWIPER.init()
}
